import { css } from '@emotion/react';
import { ComponentChildren, h } from 'preact';

export const Triangle = ({ style }: { style?: preact.JSX.CSSProperties }) => (
  <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
    <mask
      id="mask0_3321_2686"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="-40"
      y="-29"
      width="139"
      height="37"
    >
      <path
        d="M84 -29C92.2843 -29 99 -22.2843 99 -14C99 -5.71573 92.2843 1 84 1H9.71875L4.80566 7C4.36179 7.54205 3.53074 7.47419 3.19043 6.86816L-0.102539 1H-25C-33.2843 1 -40 -5.71573 -40 -14C-40 -22.2843 -33.2843 -29 -25 -29H84Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3321_2686)">
      <path
        d="M9.71875 1V0H9.24511L8.94505 0.366453L9.71875 1ZM-0.102539 1L0.769535 0.510628L0.482994 0H-0.102539V1ZM84 -29V-28C91.732 -28 98 -21.732 98 -14H99H100C100 -22.8366 92.8366 -30 84 -30V-29ZM99 -14H98C98 -6.26801 91.732 0 84 0V1V2C92.8366 2 100 -5.16344 100 -14H99ZM84 1V0H9.71875V1V2H84V1ZM9.71875 1L8.94505 0.366453L4.03196 6.36645L4.80566 7L5.57935 7.63357L10.4925 1.63355L9.71875 1ZM4.80566 7L4.03196 6.36645C4.02842 6.37079 4.02666 6.37192 4.0272 6.37152C4.02764 6.37119 4.02892 6.37036 4.03084 6.36957C4.0345 6.36805 4.03779 6.3677 4.04057 6.36792C4.04336 6.36815 4.04847 6.36922 4.05476 6.37316C4.05797 6.37517 4.06061 6.37741 4.06246 6.37934C4.06421 6.38244 4.0644 6.38137 4.06246 6.37934L3.19043 6.86816L2.31835 7.35754C3.01018 8.58956 4.69799 8.70986 5.57935 7.63357L4.80566 7ZM3.19043 6.86816L4.06246 6.37934L0.769535 0.510628L-0.102539 1L-0.974613 1.48937L2.31835 7.35754L3.19043 6.86816ZM-0.102539 1V0H-25V1V2H-0.102539V1ZM-25 1V0C-32.732 0 -39 -6.26801 -39 -14H-40H-41C-41 -5.16344 -33.8366 2 -25 2V1ZM-40 -14H-39C-39 -21.732 -32.732 -28 -25 -28V-29V-30C-33.8366 -30 -41 -22.8366 -41 -14H-40ZM-25 -29V-28H84V-29V-30H-25V-29Z"
        fill="white"
        fill-opacity="0.52"
      />
    </g>
  </svg>
);

const tipsBubbleStyle = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #4f396d;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  border-radius: 20px;
  padding: 0 16px;
  min-height: 32px;
  min-width: 40px;
  position: relative;
  box-sizing: border-box;
  white-space: nowrap;
  text-overflow: ellipsis;
  border: 1px solid rgba(255, 255, 255, 0.52);
`;

const triangleStyle = css`
  position: absolute;
  left: 20%;
  bottom: -9px;
  transform: translateX(-50%);
  z-index: 2;
  pointer-events: none;
`;

export function TipsBubble({
  children,
  style
}: {
  children: ComponentChildren;
  style?: preact.JSX.CSSProperties;
}) {
  return (
    <div style={`${tipsBubbleStyle.styles} ${style}`}>
      {children}
      <svg style={`${triangleStyle.styles} `} width="18" height="10" viewBox="0 0 18 10">
        <polygon points="9,10 0,1 18,1" fill="#ffffff52" />
        <polygon points="9,9 2,1 16,1" fill="#4F396D" />
      </svg>
    </div>
  );
}
